/* eslint-disable */
import React, { memo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { TooltipProps, Typography } from '@mui/material';
import { AppDispatch, RootState } from '../../../store/store';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setSnackBarOpen } from '../../../store/reducers/snackbar/snackBarOpenSlice';
import { setSnackBarMessageType } from '../../../store/reducers/snackbar/snackBarMessageTypeSlice';
import { setSnackBarMessage } from '../../../store/reducers/snackbar/snackBarMessageSlice';

enum MessageType {
 ERROR = 'error',
 SUCCESS = 'success',
 WARNING = 'warning',
 INFORMATION = 'info',
}

const useStyles = makeStyles({
 typography: {
  color: '#FFB614',
  borderRadius: '5px',
  height: '8px',
  marginTop: '-20px',
  display: 'flex',
  flexDirection: 'column',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'center',
 },
});

/**
 * Сохранить и передать клиенутый id в главную форму.
 * @param props
 * @returns
 */
const CellRenderClipboard = (props: any, money: boolean) => {
 const dispatch = useDispatch<AppDispatch>();

 const field = props?.column.colId;
 const value = props.value;
 const valueFormatted = props.valueFormatted;

 const classes = useStyles();
 const [data, setData] = useState(false);

 const copy = () => {};

 const onMouseOver = () => {
  setData(true);
 };

 const onMouseLeave = () => {
  setData(false);
 };

 const onCopy = () => {
  dispatch(setSnackBarOpen(true));
  dispatch(setSnackBarMessageType(MessageType.SUCCESS));
  dispatch(setSnackBarMessage('Скопировано.'));
 };

 const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
 ))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
   backgroundColor: 'white',
   width: '93%',
   fontSize: theme.typography.pxToRem(12),
  },
 }));

 return (
  <div onMouseOver={onMouseOver} onMouseLeave={onMouseLeave}>
   {data ? (
    <CopyToClipboard text={value} onCopy={onCopy}>
     <div style={{ display: 'flex', alignItems: 'center' }}>
      {valueFormatted ? valueFormatted : value}

      {/* <HtmlTooltip
       sx={{
        borderRadius: '5px',
        backgroundColor: 'transparent',
        color: 'black',
        left: '50px !important',
        top: '-50px  !important',
       }}
       title={
        <Typography className={classes.typography} color="inherit">
         <label
          style={{
           display: 'flex',
           flexDirection: 'column',
           justifyContent: 'center',
           justifyItems: 'center',
           alignContent: 'center',
           alignItems: 'center',
           fontSize: '12px',
           color: '#7056F7',
          }}
         >
          Копировать
         </label>
        </Typography>
       }
      > */}
      <ContentCopyIcon
       style={{
        height: '11px',
        marginLeft: '5px',
        cursor: 'pointer',
        fill: '#383B3F',
       }}
      />
      {/* </HtmlTooltip> */}
     </div>
    </CopyToClipboard>
   ) : valueFormatted ? (
    valueFormatted
   ) : (
    value
   )}
  </div>
 );
};

export default memo(CellRenderClipboard);
